import { render, staticRenderFns } from "./FlickerIndexCardInfo.vue?vue&type=template&id=076fa866&scoped=true&"
import script from "./FlickerIndexCardInfo.vue?vue&type=script&lang=js&"
export * from "./FlickerIndexCardInfo.vue?vue&type=script&lang=js&"
import style0 from "./FlickerIndexCardInfo.vue?vue&type=style&index=0&id=076fa866&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076fa866",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
